<div class="alert {{ alertData.styleClass }} alert-dismissible p-2 m-0" role="alert">
    <div class="row p-0 m-0">
        <div class="col-1 d-flex align-items-center justify-content-center p-0 mr-1">
            <i *ngIf="alertData.styleClass === 'alert-warning'" class="bi bi-exclamation-triangle" style="font-size: 21px; color: #ff9f43;"></i>
            <i *ngIf="alertData.styleClass === 'alert-danger'" class="bi bi-exclamation-circle" style="font-size: 21px; color: #ff4343;"></i>
            <i *ngIf="alertData.styleClass === 'alert-success'" class="bi bi-check-circle" style="font-size: 21px; color: #149014;"></i>
        </div>
        <div class="col p-0 m-0">
           <div class="row">
            <div class="col p-0 m-0">
                <strong class="" style="font-size: 16px;">{{ alertData.heading }}</strong>  
            </div>
           </div>
           <div class="row">
            <div class="col p-0 m-0">
                <span style="font-size: 12px;" [innerHTML]="alertData.message2"></span>
            </div>
           </div>
        </div>
      </div>
</div>
